import React from 'react'
import './fallbackspinner.css'

const FallbackSpinner = () => {
  return (
    
    <div className='d-flex justify-content-center mt-9'>
        <div className="circle"></div>
        <span className='loading'>loading...</span>
    </div>
  )
}

export default FallbackSpinner